import { render, staticRenderFns } from "./CardAlertas.vue?vue&type=template&id=58a95ee5&scoped=true"
import script from "./CardAlertas.vue?vue&type=script&lang=ts"
export * from "./CardAlertas.vue?vue&type=script&lang=ts"
import style0 from "./CardAlertas.vue?vue&type=style&index=0&id=58a95ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a95ee5",
  null
  
)

export default component.exports